<script>
import headBox from "@/components/head.vue"
import footBox from "@/components/foot.vue"
import {getText} from "@/utils/text";

export default {
  components: {headBox, footBox},
  data() {
    return {}
  },
  methods: {
    getViewText(key) {
      return getText(key)
    }
  }
}
</script>


<template>
  <div>
    <headBox/>

    <section id="content" lang=ZH-CN link="#467886" vlink="#96607D" style='tab-interval:21.0pt;
        word-wrap:break-word;text-justify-trim:punctuation'>

      <div :class="$store.state.isPhone?'WordSection':'WordSection1'" style='layout-grid:15.6pt'>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US style='font-size:17.0pt;line-height:
        200%;font-family:"Meiryo",sans-serif;'>{{ getViewText('about_us') }}</span></b><b><span
          lang=EN-US style='font-size:16.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:
        Arial'></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
        200%;font-family:"Meiryo",sans-serif;'>{{ getViewText('our_company') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
        line-height:200%;font-family:"Meiryo",sans-serif;
        '>{{getViewText('au_1')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif;
        '>{{ getViewText('au_2')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
        200%;font-family:"Meiryo",sans-serif;'>{{ getViewText('our_team') }} </span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif;
        '>{{ getViewText('au_3')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif;
        '>{{getViewText('au_4')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
        line-height:200%;font-family:"Meiryo",sans-serif;'>{{getViewText('au_5')}}:</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;font-size: 18px;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%;tab-stops:
        list 36.0pt'><![if !supportLists]><span lang=EN-US style='font-size:10.0pt;
        mso-bidi-font-size:10.5pt;line-height:200%;font-family:Symbol;mso-fareast-font-family:
        Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'><span
          style='font:7.0pt "Times New Roman"'>
        </span></span></span><![endif]>
          <span lang=EN-US>
                <router-link :to="{ name: 'termsconditions' }">
                    <span style='text-decoration: underline; line-height:200%;font-family:"Meiryo",sans-serif;'>
                        {{ getViewText('terms') }} &amp; {{ getViewText('conditions') }}
                    </span>
                </router-link>
            </span>
          <span lang=EN-US style='mso-bidi-font-size:10.5pt;line-height:200%;font-family:"Meiryo",sans-serif; '></span>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt; margin-bottom:15.6pt;text-align:
        left;line-height:200%;    font-size: 18px;tab-stops:
        list 36.0pt'><![if !supportLists]><span lang=EN-US style='font-size:10.0pt;
        mso-bidi-font-size:10.5pt;line-height:200%;font-family:Symbol;mso-fareast-font-family:
        Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'><span
          style='font:7.0pt "Times New Roman"'>
        </span></span></span><![endif]>
          <span lang=EN-US>
            <router-link :to="{ name: 'privacypolicy' }">
                <span style='text-decoration: underline; line-height:200%;font-family:"Meiryo",sans-serif;'>
                    {{ getViewText('privacy_policy') }}
                </span>
            </router-link>
        </span>
          <span lang=EN-US
                style='mso-bidi-font-size: 10.5pt;line-height:200%;font-family:"Meiryo",sans-serif;mso-bidi-font-family: Arial'></span>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;font-size: 18px;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%;tab-stops:
        list 36.0pt'><![if !supportLists]><span lang=EN-US style='font-size:10.0pt;
        mso-bidi-font-size:10.5pt;line-height:200%;font-family:Symbol;mso-fareast-font-family:
        Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'><span
          style='font:7.0pt "Times New Roman"'>
        </span></span></span><![endif]>

          <span lang=EN-US>
                <router-link :to="{ name: 'refundpolicy' }">
                    <span style='text-decoration: underline; line-height:200%;font-family:"Meiryo",sans-serif;'>
                        {{ getViewText('refund_policy') }}
                    </span>
                </router-link>
            </span>
          <span lang=EN-US
                style='line-height:200%;font-family:"Meiryo",sans-serif; '>
            </span>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;    font-size: 18px;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%;tab-stops:
        list 36.0pt'><![if !supportLists]><span lang=EN-US style='font-size:10.0pt;
        mso-bidi-font-size:10.5pt;line-height:200%;font-family:Symbol;mso-fareast-font-family:
        Symbol;mso-bidi-font-family:Symbol'><span style='mso-list:Ignore'><span
          style='font:7.0pt "Times New Roman"'>
        </span></span></span><![endif]>
          <span lang=EN-US>
                <router-link :to="{ name: 'contactus' }">
                    <span style='text-decoration: underline; line-height:200%; font-family:"Meiryo", sans-serif;'>
                        {{getViewText('contact_us')}}
                    </span>
                </router-link>
            </span>
          <span lang=EN-US style='mso-bidi-font-size:10.5pt; line-height:200%;font-family:"Meiryo",sans-serif;'>
            </span>
        </p>

      </div>

    </section>

    <footBox/>
  </div>
</template>
<style>
.WordSection1 {
  margin-left: 105.0pt;
  margin-right: 105.0pt;
  color: #fff
}

.WordSection {
  margin-left: 50px;
  margin-right: 50px;
  color: #fff
}


</style>



// WEBPACK FOOTER //
// src/views/aboutus.vue